import { Box, Fade, IconButton, Modal, Typography } from "@mui/material";
import React, { FC } from "react";
import { theme } from "../../theme";
import useViewport from "../../hooks/useViewport";
import getREMFromPX from "../../utils/getREMFromPX";
import CloseIcon from "@mui/icons-material/Close";
import useGetThemePath, { getThemePath } from "../../hooks/useGetThemePath";

const themePath = getThemePath();
const { colors } = theme[themePath];

const modalStyles: any = {
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 15.5px",
  },
  paper: {
    backgroundColor: colors.white || "#ffffff",
    maxWidth: {
      md: getREMFromPX(510),
      xs: undefined,
    },
    width: "100%",
    flexGrow: 0,
    objectFit: "contain",
    borderRadius: getREMFromPX(20),
    outline: "none",
    boxShadow: "0 4px 10px 0 rgba(0, 0, 0, 0.25)",
    position: "relative",
    overflow: "hidden",
    maxHeight: "90%",
  },
  closeButton: {
    position: "absolute",
    top: 15,
    right: 15,
    color: colors.textPrimary.headingAlt,
  },
};

interface CustomModalProps {
  open: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  title?: string;
}

export const ProfileSettingsModal: FC<CustomModalProps> = ({
  open,
  onClose,
  children,
  title,
}) => {
  const themePath = useGetThemePath();
  const { colors } = theme[themePath];
  const { isMobile } = useViewport();
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      sx={modalStyles.modal}
    >
      <Fade in={open}>
        <Box
          sx={{
            ...modalStyles.paper,
            padding: !isMobile ? "80px 40px 30px" : "16px 16px",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          {!!title && (
            <Typography
              sx={{
                position: "absolute",
                top: {
                  md: 30,
                  xs: 14,
                },
                pl: 3,
                fontFamily: "Inter",
                fontSize: getREMFromPX(20),
                fontWeight: "500",
                fontStyle: "normal",
                letterSpacing: 0,
                textAlign: "left",
                color: colors.textPrimary.heading,
                height: 40,
                width: "100%",
                backgroundColor: colors.white || "#ffffff",
              }}
            >
              {title}
            </Typography>
          )}
          <IconButton
            sx={{
              position: "absolute",
              top: {
                md: 15,
                xs: 6,
              },
              right: 15,
              color: colors.links.teal,
            }}
            onClick={onClose}
            data-cy="profile-mydetails-close"
          >
            <CloseIcon
              sx={{ fontWeight: "bolder" }}
              fill={colors.icons.default.fillColor}
              fontSize="large"
            />
          </IconButton>
          {children}
        </Box>
      </Fade>
    </Modal>
  );
};
